import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form as FormSchema } from 'factorial-form'

import { observer } from 'mobx-react'

import Form from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import CurrencySelector from 'modules/settings/components/CurrencySelector'

class CurrencyForm extends FormSchema {
  constructor(values: object) {
    super(values, {
      currency: 'string',
    })
  }
}
interface Props {
  legalEntity: LegalEntity
}

const CurrencyBlock: React.FC<Props> = ({ legalEntity }: Props) => {
  const form = useLazyRef(() => new CurrencyForm(legalEntity.toJS())).current

  const onSubmit = async () => {
    await asyncAction(() => legalEntity.save(form.data()))
    form.cleanAll()
  }

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="coins"
        title={i18n.t('settings.edit_company.currency_form.title')}
        description={i18n.t('settings.edit_company.currency_form.description')}
      />
      <Form onSubmit={onSubmit}>
        <FormRow>
          <CurrencySelector field={form.get('currency')} />
        </FormRow>

        {form.isDirty && (
          <FormRow footer>
            <Button submit>{i18n.t('common.submit')}</Button>
          </FormRow>
        )}
      </Form>
    </PanesPadForm>
  )
}

export default observer(CurrencyBlock)
